import { Link } from "react-router-dom";

const Project = () => {
  function Project(props) {
    return (
      <div className="project">
        <img
          src={require("../../assets/img/projects/projet0" +
            props.number +
            ".png")}
          alt=""
        />
        <div className="project-info-card">
          <article className="project-info">
            <h3>{props.title}</h3>
            <p className="project-description">{props.desc}</p>
            <p className="project-tag">{props.tag}</p>
          </article>
          <div className="project-icon">
            <i class={props.icon}></i>
          </div>
        </div>
      </div>
    );
  }
  return (
    <section className="project-section" id="project">
      <h2>Projets</h2>
      <article>
        <Project
          number="1"
          title="JPPCompta"
          desc="Expertise fiable pour une gestion toujours sereine."
          tag="React Native"
          icon="fa-solid fa-table-list"
        ></Project>
        <Project
          number="2"
          title="Le 393"
          desc="Une cuisine maison, savoureuse et toujours conviviale."
          tag="React Native"
          icon="fa-solid fa-utensils"
        ></Project>
      </article>
      <Link to="/projects" className="btn see-all">
        Voir tout
      </Link>

      <div className="color-form blue"></div>
    </section>
  );
};

export default Project;
